import VideoBase from "./VideoBase";

/// <reference path="../window.d.ts" />

export default class MP4Video extends VideoBase {
  _load = () => {
    return new Promise((resolve) => {
      window.Shopify.loadFeatures([
        {
          name: 'video-ui',
          version: '1.0',
          onLoad: function () {
            resolve(window.Shopify.Plyr);
          },
        },
      ]);
    });
  }

  init = ({ autoplay, hideControls, url, mute, loop, onPlay, onEnd }) => {
    autoplay = this.getAutoplay(autoplay);

    return new Promise((resolve, reject) => {
      this._load().then(
        (Plyr) => {
          this.player = new Plyr(this.element, {
            loop: {
              active: loop,
            },
            autoplay: autoplay,
            muted: mute,
            fullscreen: {
              enabled: false,
            },
          });

          this.player.on('ready', (event) => {
            this.player = event.detail.plyr;
            if (autoplay) {
              this.player.play();
            }
            if (hideControls) {
              this.player.toggleControls(false);
            }
            resolve();
          });

          this.player.on('playing', () => {
            onPlay();
          });

          this.player.on('ended', () => {
            onEnd();
          });
        }
      );
    });
  }
}
